import { SidebarMode } from './types';

export function isSidebarMode(u: unknown): u is SidebarMode {
  return typeof u === 'string' && Object.values(SidebarMode).some(v => v === u);
}
